module.exports = __webpack_public_path__ + "img/abstract3.76a707b.svg";